import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/customer"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const EditDetails = async (values) => {
    return await axiosInstance(options).put(`${path}/edit-details`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/delete-user?_id=${values._id}`, values)
}

export const Details = async (value) => {
    return await axiosInstance(options).get(`${path}/get-details?_id=${value._id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/block-user`, values)
}